import { Box, Heading } from '@zillow/constellation-10';
import { LoadingButton, LoadingHeading } from '@zg-rentals/loading-components';

import { useCompletionStatusQuery, useLeaseQuery, usePropertyInfoQuery } from '../../shared/utils/queries';
import { LeaseTypes } from '../../shared/models/Types';
import LeaseViewModeToggle from './LeaseViewModeToggle';
import { useLeasingUrlParams } from '../hooks/useLeasingUrlParams';

type Props = {
  isSelfServe?: boolean;
};

function ProgressAndSummaryHeader({ isSelfServe }: Props): JSX.Element | null {
  const { leaseId, propertyId } = useLeasingUrlParams();
  const leaseQuery = useLeaseQuery(leaseId);
  const propertyQuery = usePropertyInfoQuery(propertyId, !!propertyId);
  const lease = leaseQuery.data;
  const property = propertyQuery.data;

  useCompletionStatusQuery(leaseId, {
    enabled: !!leaseId && !isSelfServe && !!lease && lease.leaseType !== LeaseTypes.COSMOS,
  });

  const isLoading = propertyQuery.isLoading || leaseQuery.isLoading;

  if (isLoading) {
    return (
      <Box
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: { base: 'tight', mdDown: 'tighter' },
        }}
      >
        <LoadingHeading
          isLoading
          level={3}
          css={{
            textStyle:
              'responsive.heading-xs' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
          }}
          loadingWidth="40%"
        >
          Loading
        </LoadingHeading>
        <LoadingButton isLoading loadingWidth="25%">
          Loading
        </LoadingButton>
      </Box>
    );
  }

  return property == null ? null : (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: { base: 'tight', mdDown: 'tighter' },
      }}
    >
      <Heading
        level={2}
        css={{
          textStyle:
            'responsive.heading-sm' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
        }}
      >
        {isSelfServe ? 'Your lease package' : 'Create your lease'}
      </Heading>
      {!isSelfServe && <LeaseViewModeToggle />}
    </Box>
  );
}

export default ProgressAndSummaryHeader;
